import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Text, chakra } from '@chakra-ui/react';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/Button';
import { Card, CardBody } from '@/components/ui/Card';

export function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(password);
      navigate('/watchlist');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Invalid password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="bg.secondary"
      p="4"
    >
      <Card w="full" maxW="400px">
        <CardBody>
          <Box textAlign="center" mb="8">
            <Text as="h1" fontSize="24px" fontWeight="600" color="text.primary" mb="2">
              Market Buddy
            </Text>
            <Text fontSize="14px" color="text.tertiary">
              Enter your password to continue
            </Text>
          </Box>

          <chakra.form onSubmit={handleSubmit} display="flex" flexDirection="column" gap="4">
            <Box>
              <chakra.label
                htmlFor="password"
                display="block"
                fontSize="14px"
                fontWeight="500"
                color="text.secondary"
                mb="1"
              >
                Password
              </chakra.label>
              <chakra.input
                id="password"
                type="password"
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                placeholder="Enter your password"
                autoFocus
                w="full"
                px="4"
                py="3"
                borderRadius="md"
                border="1px solid"
                borderColor="border.primary"
                bg="bg.primary"
                fontSize={{ base: '16px', md: '14px' }}
                lineHeight="20px"
                color="text.primary"
                outline="none"
              />
            </Box>

            {error && (
              <Text
                fontSize="14px"
                color="status.error.text"
                bg="status.error.bg"
                px="3"
                py="2"
                borderRadius="sm"
              >
                {error}
              </Text>
            )}

            <Button type="submit" fullWidth loading={loading}>
              Sign in
            </Button>
          </chakra.form>
        </CardBody>
      </Card>
    </Flex>
  );
}
